import React from 'react';
import { Link } from 'react-router-dom';
import PoweredBy from '../common/PoweredBy';
import { useStoreContext } from '../../contexts/StoreContext';

// Layout two-column pras páginas auth: formulário à esquerda, hero à direita.
// Em <md colapsa e mostra só o formulário.
//
// Whitelabel: quando o tenant tá resolvido (isStoreSite), exibe o nome da
// loja no logo e nas mensagens — sem mencionar "Reviter". Backoffice
// (hideStoreBranding=true) força branding institucional Reviter.
const AuthLayout = ({ title, subtitle, children, footer, heroContent, hideStoreBranding = false }) => {
  const { store, isStoreSite } = useStoreContext();
  const useStoreBranding = isStoreSite && !hideStoreBranding;
  const brandName = useStoreBranding ? store?.name || 'Loja' : 'Reviter';

  // Em fluxos de backoffice, ignoramos a branding da store e usamos
  // gradient default Reviter. O AppWrapper aplica vars CSS da store em
  // rotas whitelabel, então quando hideStoreBranding=true forçamos cores
  // fixas (cinza/preto) via inline style override.
  const heroStyle = hideStoreBranding
    ? { background: 'linear-gradient(135deg, #1f2937, #111827)' }
    : {
        background:
          'linear-gradient(135deg, rgb(var(--color-primary-rgb)), rgb(var(--color-secondary-rgb)))',
      };
  return (
    <div className="min-h-[calc(100dvh-60px)] flex">
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/" className="inline-block mb-8 text-2xl font-extrabold text-primary truncate max-w-full">
            {brandName}
          </Link>
          <h1 className="text-3xl font-extrabold text-app-text mb-2">{title}</h1>
          {subtitle && <p className="text-app-text-secondary mb-8">{subtitle}</p>}
          {children}
          {footer && <div className="mt-6 text-center text-sm">{footer}</div>}
        </div>
        {!useStoreBranding && (
          <div className="mt-8">
            <PoweredBy variant="dark" />
          </div>
        )}
      </div>

      <div
        className="hidden md:flex md:flex-1 relative overflow-hidden items-center justify-center p-12"
        style={heroStyle}
      >
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-white/30 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-white/20 blur-3xl" />
        </div>
        <div className="relative text-white max-w-md">
          {heroContent || (
            <>
              <h2 className="text-4xl font-extrabold mb-4 leading-tight">
                {hideStoreBranding ? (
                  <>Backoffice<br />Reviter.</>
                ) : useStoreBranding ? (
                  <>Bem-vindo a<br />{store?.name || 'nossa loja'}.</>
                ) : (
                  <>Sua loja online,<br />do seu jeito.</>
                )}
              </h2>
              <p className="text-lg text-white/90">
                {hideStoreBranding
                  ? 'Acesso para administradores Reviter e gestores de loja.'
                  : useStoreBranding
                  ? 'Acesse sua conta pra acompanhar pedidos, favoritos e endereços.'
                  : 'Plataforma multi-tenant pra donos de loja, revendedores e clientes — tudo em um só lugar.'}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
